import React, { Component } from "react"
import { ModalContainer } from "react-modal-dialog"
import { Loading } from "../../components"
export default class LoadModal extends Component {
  render() {
    return (
      <div onClick={this.props.onClose}>
        {this.props.show && (
          <ModalContainer onClose={this.props.onClose}>
            <Loading
              style={{
                position: "absolute",
                top: "50%",
                right: 0,
                left: 0
              }}
            />
          </ModalContainer>
        )}
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/views/modais/LoadModal.js